import { Box, Checkbox, Typography, useScrollTrigger } from "@mui/material";
import { useState } from "react";

const ChooseDeliverType = ({ delvType, onChange, userProvided }: any) => {
  const selected = delvType;
  return (
    <Box
      sx={{
        px: { md: "2%", lg: "2%", xl: "2%", sm: "4%", xs: "4%" },
        py: "0px",
      }}
    >
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "18px",
          lineHeight: "31px",
          mt: "20px",
          mb: "10px",
        }}
      >
        How would you like to get your equipment?
      </Typography>

      <Box
        sx={{
          display: {
            md: "flex",
            lg: "flex",
            xl: "flex",
            sm: "none",
            xs: "none",
          },
          gap: "25px",
        }}
      >
        <Box
          component="label"
          sx={{ display: "flex", alignItems: "center", gap: "20px" }}
        >
          <Checkbox
            sx={{ padding: "0px" }}
            checkedIcon={
              <img src="/assets/img/icons/radio_checked.svg" alt="" />
            }
            icon={<img src="/assets/img/icons/radio_unchecked.svg" alt="" />}
            onClick={() => userProvided === 1 && onChange(0)}
            checked={selected === 0}
            // disabled={selected === 1}
          />
          <Typography
            sx={{ fontWeight: 500, fontSize: "15px", lineHeight: "19px" }}
          >
            Pickup
          </Typography>
        </Box>

        {userProvided === 1 && (
          <Box
            component="label"
            sx={{ display: "flex", alignItems: "center", gap: "20px" }}
          >
            <Checkbox
              sx={{ padding: "0px" }}
              checkedIcon={
                <img src="/assets/img/icons/radio_checked.svg" alt="" />
              }
              icon={<img src="/assets/img/icons/radio_unchecked.svg" alt="" />}
              onClick={() => userProvided === 1 && onChange(1)}
              checked={selected === 1}
              // disabled={selected === 0}
            />
            <Typography
              sx={{ fontWeight: 500, fontSize: "15px", lineHeight: "19px" }}
            >
              Delivery
            </Typography>
          </Box>
        )}
      </Box>

      <Box
        sx={{
          display: {
            md: "none",
            lg: "none",
            xl: "none",
            sm: "flex",
            xs: "flex",
            flexDirection: "column",
          },
          gap: "25px",
        }}
      >
        <Box
          component="label"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "20px",
            width: "100%",
          }}
        >
          <Typography
            sx={{ fontWeight: 500, fontSize: "15px", lineHeight: "19px" }}
          >
            Pickup
          </Typography>
          <Checkbox
            sx={{ padding: "0px" }}
            checkedIcon={
              <img src="/assets/img/icons/radio_checked.svg" alt="" />
            }
            icon={<img src="/assets/img/icons/radio_unchecked.svg" alt="" />}
            onClick={() => userProvided === 1 && onChange(0)}
            checked={selected === 0}
            // disabled={selected === 1}
          />
        </Box>

        <Box sx={{ height: "1px", background: "#E9E9E9", width: "100%" }} />

        {userProvided === 1 && (
          <Box
            component="label"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "20px",
            }}
          >
            <Typography
              sx={{ fontWeight: 500, fontSize: "15px", lineHeight: "19px" }}
            >
              Delivery
            </Typography>
            <Checkbox
              sx={{ padding: "0px" }}
              checkedIcon={
                <img src="/assets/img/icons/radio_checked.svg" alt="" />
              }
              icon={<img src="/assets/img/icons/radio_unchecked.svg" alt="" />}
              onClick={() => userProvided === 1 && onChange(1)}
              checked={selected === 1}
              // disabled={selected === 0}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ChooseDeliverType;
